<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M6 12.667v-1.334h8v1.334H6Zm0-4V7.333h8v1.334H6Zm0-4V3.333h8v1.334H6Zm-2.667 8.666c-.366 0-.68-.13-.941-.391A1.284 1.284 0 0 1 2 12c0-.367.13-.68.392-.942.26-.26.575-.391.941-.391.367 0 .68.13.942.391.261.261.392.575.392.942s-.13.68-.392.942a1.284 1.284 0 0 1-.942.391Zm0-4c-.366 0-.68-.13-.941-.391A1.284 1.284 0 0 1 2 8c0-.367.13-.68.392-.942.26-.26.575-.391.941-.391.367 0 .68.13.942.391.261.261.392.575.392.942s-.13.68-.392.942a1.284 1.284 0 0 1-.942.391Zm0-4c-.366 0-.68-.13-.941-.391A1.284 1.284 0 0 1 2 4c0-.367.13-.68.392-.942.26-.26.575-.391.941-.391.367 0 .68.13.942.391.261.261.392.575.392.942s-.13.68-.392.942a1.284 1.284 0 0 1-.942.391Z"
        />
    </svg>
</template>

<script setup lang="ts">
type FormattedListIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<FormattedListIconProps>();
</script>
